import { useApiClient } from '../useApi/useApiClient';
import { ILoginRequest, ILoginResponse } from './useLogin.interfaces';

export const useLogin = () => {
    const { fetch, loading } = useApiClient<ILoginResponse>();

    const login = async (request: ILoginRequest) =>
        await fetch({
            url: '/login',
            method: 'POST',
            body: request,
        });

    return {
        login,
        loading,
    };
};
